import { FaArrowLeft } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import {
  RiLogoutCircleRLine,
  RiChatHistoryLine,
  RiStethoscopeLine,
  RiAlarmLine,
  RiHome2Line,
  RiRobot2Line,
  RiUser3Line
} from "react-icons/ri";
import { MdScience, MdOutlineMedication, MdMonitorHeart } from "react-icons/md";
import { useContext, useState } from "react";
import { FaFilePrescription } from "react-icons/fa";

import { useLocation, useNavigate } from "react-router-dom";
import languageContext from "../context/language/languageContext";

const Navbar = () => {
  const {
    lang,
    setSessionTimeout,
    dataApi,
    setData,
    setAlert,
    setMessage,
    isRightPanel,
    setIsRightPanel,
  } = useContext(languageContext);

  const navigate = useNavigate();
  const location = useLocation();
  const url = location.state?.url || "/";
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLeftPanel, setIsLeftPanel] = useState(false);

  const labels = {
    0: {
      bookAppointment: "Book Appointment",
      labAppointment: "Lab Appointment",
      setReminder: "Set Reminder",
      buyMedicine: "Buy Medicine",
      medicineInfo: "Medicine Info",
      reminderUpload: "Reminder via Prescription",
      profile: "Profile",
      home: "Home",
      logout: "Logout",
      General_Assistant:"General Assistant",
      leaveApplication:"Apply for Leave",
      rppgMonitor: "Heart Rate, SpO₂ & Blood Pressure Monitor", // 🩺 Updated label

    },
    1: {
      bookAppointment: "अपॉइंटमेंट बुक करें",
      labAppointment: "लैब अपॉइंटमेंट",
      setReminder: "रिमाइंडर सेट करें",
      buyMedicine: "दवा खरीदें",
      medicineInfo: "दवा जानकारी",
      reminderUpload: "प्रिस्क्रिप्शन से रिमाइंडर",
      profile: "प्रोफ़ाइल",
      home: "होम",
      logout: "लॉगआउट",
      General_Assistant:"सामान्य सहायक",
      leaveApplication:"छुट्टी के लिए आवेदन करें",
      rppgMonitor: "हृदय गति, ऑक्सीजन स्तर (SpO₂) और रक्तचाप मॉनिटर", // 🩺 हिंदी लेबल

    },
    2: {
      bookAppointment: "ਮੁਲਾਕਾਤ ਬੁੱਕ ਕਰੋ",
      labAppointment: "ਲੈਬ ਮੁਲਾਕਾਤ",
      setReminder: "ਰੀਮਾਈਂਡਰ ਸੈੱਟ ਕਰੋ",
      buyMedicine: "ਦਵਾਈ ਖਰੀਦੋ",
      medicineInfo: "ਦਵਾਈ ਦੀ ਜਾਣਕਾਰੀ",
      reminderUpload: "ਨੁਸਖੇ ਰਾਹੀਂ ਰੀਮਾਈਂਡਰ",
      profile: "ਪ੍ਰੋਫਾਈਲ",
      home: "ਘਰ",
      logout: "ਲਾਗ ਆਉਟ",
      General_Assistant:"ਸਧਾਰਣ ਸਹਾਇਕ",
      leaveApplication:"ਛੁੱਟੀ ਲਈ ਅਰਜ਼ੀ ਦਾਖਲ ਕਰੋ",
      rppgMonitor: "ਦਿਲ ਦੀ ਧੜਕਨ, ਆਕਸੀਜਨ ਪੱਧਰ (SpO₂) ਅਤੇ ਖੂਨ ਦਾ ਦਬਾਅ ਮੋਨੀਟਰ", // 🩺 ਪੰਜਾਬੀ ਲੇਬਲ

    },
  }[lang || 0];

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("login");
    navigate("/");
  };

  const handleBackArrowPress = () => navigate(url);
  const handlehome = () => navigate("/ask");
  const handleprofile = () => navigate("/account");
  const handleBookAppointment = () => navigate("/book_appointment");
  const handlelabAppointment = () => navigate("/lab_book");
  const handlereminderAppointment = () => navigate("/reminder");
  const handleMedicine = () => navigate("/buy_medicine");
  const handleGeneralAssistant = () => navigate("/general_serach");
  const handleMedicineChatbot = () => navigate("/medicine_chat");
  const handleReminderUpload = () => navigate("/reminder_upload");
  const handleLeaveApplication =()=> navigate("/leave_application")
  const handlerrpd =()=>navigate("/RPPGWebcam")

  const navButton = (onClick, label, Icon, color = "blue") => (
    <button
      onClick={onClick}
      className={`bg-${color}-600 text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-${color}-700 transition duration-300 flex items-center gap-2`}
    >
      <Icon size={18} />
      {label}
    </button>
  );

  const secondaryButton = (onClick, label, Icon, color = "blue") => (
    <button
      onClick={onClick}
      className={`bg-${color}-600 text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-${color}-700 transition duration-300 flex items-center gap-2`}
    >
      <Icon className="text-sky-700" size={18} />
      {label}
    </button>
  );

  const mobilenavButton = (onClick, label, Icon) => (
    <button
      onClick={onClick}
      className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-blue-700 transition duration-300 flex items-center gap-2"
    >
      <Icon size={18} />
      <span>{label}</span>
    </button>
  );

  const mobilesecondaryButton = (onClick, label, Icon) => (
    <button
      onClick={onClick}
      className="bg-sky-600 text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-sky-700 transition duration-300 flex items-center gap-2"
    >
      <Icon size={18} />
      <span>{label}</span>
    </button>
  );

  return (
    <div className="bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 w-full h-[70px] md:h-[80px] flex items-center justify-between px-6 shadow-lg">
      <div className="flex items-center space-x-4">
        <div
          className="w-[40px] h-[40px] bg-gray-700 text-white rounded-full flex justify-center items-center cursor-pointer hover:bg-blue-600 transition"
          onClick={handleBackArrowPress}
        >
          <FaArrowLeft size="1.4rem" />
        </div>

        {localStorage.getItem("login") && location.pathname.includes("/ask") && (
          <div
            className="md:hidden w-[40px] h-[40px] bg-gray-700 text-white rounded-full flex justify-center items-center cursor-pointer hover:bg-blue-600 transition"
            onClick={() => {
              setIsRightPanel(false);
              setIsLeftPanel(!isLeftPanel);
            }}
          >
            <RiChatHistoryLine size="1.4rem" />
          </div>
        )}
      </div>

      <div className="hidden md:flex items-center space-x-3">
        {location.pathname.includes("/ask") && (
          <>
            {navButton(handleBookAppointment, labels.bookAppointment, RiStethoscopeLine)}
            {navButton(handlelabAppointment, labels.labAppointment, MdScience)}
            {navButton(handlereminderAppointment, labels.setReminder, RiAlarmLine)}
            {navButton(handleMedicine, labels.buyMedicine, MdOutlineMedication)}
            {navButton(handleLeaveApplication, labels.leaveApplication, FaFilePrescription)}

            {/* {navButton(handleGeneralAssistant, labels.General_Assistant, RiRobot2Line)} */}
            {secondaryButton(handleMedicineChatbot, labels.medicineInfo, MdOutlineMedication)}
            {secondaryButton(handleReminderUpload, labels.reminderUpload, FaFilePrescription)}
            {navButton(handlerrpd, labels.rppgMonitor,MdMonitorHeart )}
            {navButton(handleprofile, labels.profile, RiUser3Line)}
           
          </>
        )}

        {[
          'RPPGWebcam',
          "/book_appointment",
          "/lab_book",
          "/reminder",
          "/buy_medicine",
          "/general_serach",
          "/checklist",
          "/account",
          "/reminder_upload",
          "leave_application"
        ].some((path) => location.pathname.includes(path)) && (
          <>
            {navButton(handlehome, labels.home, RiHome2Line)}
            {secondaryButton(handleMedicineChatbot, labels.medicineInfo, MdOutlineMedication)}
            {navButton(handleprofile, labels.profile, RiUser3Line)}
          </>
        )}

        {["/medicine_chat"].some((path) => location.pathname.includes(path)) && (
          <>
            {navButton(handlehome, labels.home, RiHome2Line)}
            {navButton(handlerrpd, labels.rppgMonitor, MdMonitorHeart)}
            {navButton(handleprofile, labels.profile, RiUser3Line)}
            
          </>
        )}
      </div>

      <div className="md:hidden flex items-center space-x-4">
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="w-[40px] h-[40px] bg-gray-700 text-white rounded-full flex justify-center items-center cursor-pointer hover:bg-blue-600 transition"
        >
          <GiHamburgerMenu size="1.5rem" />
        </button>
      </div>

      <div className="hidden md:flex items-center space-x-4">
        <div
          className="w-[44px] h-[44px] bg-red-600 text-white rounded-full flex justify-center items-center cursor-pointer hover:bg-red-700 transition"
          onClick={logout}
        >
          <RiLogoutCircleRLine size="1.4rem" />
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="fixed top-[70px] right-4 w-[85%] max-w-xs bg-white shadow-xl rounded-xl z-[9999] p-4 flex flex-col space-y-3">
          {location.pathname.includes("/ask") && (
            <>
              {mobilenavButton(handleBookAppointment, labels.bookAppointment, RiStethoscopeLine)}
              {mobilenavButton(handlelabAppointment, labels.labAppointment, MdScience)}
              {mobilenavButton(handlereminderAppointment, labels.setReminder, RiAlarmLine)}
              {mobilenavButton(handleMedicine, labels.buyMedicine, MdOutlineMedication)}
              {/* {navButton(handleGeneralAssistant, labels.General_Assistant, RiRobot2Line)} */}
              {mobilenavButton(handleLeaveApplication, labels.leaveApplication, FaFilePrescription)}
              {mobilesecondaryButton(handleMedicineChatbot, labels.medicineInfo, MdOutlineMedication)}
              {mobilesecondaryButton(handleReminderUpload, labels.reminderUpload, FaFilePrescription)}
              {mobilenavButton(handlerrpd, labels.rppgMonitor, MdMonitorHeart)}
              {mobilenavButton(handleprofile, labels.profile, RiUser3Line)}
             
            </>
          )}

          {[
            "RPPGWebcam",
            "/book_appointment",
            "/lab_book",
            "/reminder",
            "/buy_medicine",
            "/general_serach",
            "/checklist",
            "/account",
            "/reminder_upload",
            "/leave_application"
          ].some((path) => location.pathname.includes(path)) && (
            <>
              {mobilenavButton(handlehome, labels.home, RiHome2Line)}
              {mobilesecondaryButton(handleMedicineChatbot, labels.medicineInfo, MdOutlineMedication)}
              {mobilenavButton(handleprofile, labels.profile, RiUser3Line)}
            </>
          )}

          {["/medicine_chat"].some((path) => location.pathname.includes(path)) && (
            <>
              {mobilenavButton(handlehome, labels.home, RiHome2Line)}
              {mobilenavButton(handlerrpd, labels.rppgMonitor, MdMonitorHeart)}
              {mobilenavButton(handleprofile, labels.profile, RiUser3Line)}
              
            </>
          )}

          {navButton(logout, labels.logout, RiLogoutCircleRLine, "red")}
          
        </div>
      )}
    </div>
  );
};

export default Navbar;
